<template>
  <div class="">
    <!-- Header -->
    <ProjectHeader class="mb-8 mx-4 mt-4" 
      :project="project"
    />

    <!-- Tabs Navigation -->
    <div class="tabs flex border-b border-gray-300 mb-4">
      <button
        v-for="tab in tabs"
        :key="tab"
        @click="activeTab = tab"
        :class="[
          'text-sm font-medium w-full flex justify-center !h-fit !p-0 !bg-transparent cursor-pointer',
          activeTab === tab ? '' : 'hover:text-[#E8535D]'
        ]"
      >
        <div class="w-fit">
          <div class="mb-1">{{ tab }}</div>
          <div v-if="activeTab === tab" class="h-1 bg-[#E8535D] w-full rounded-t-full">
        </div>

        </div>
      </button>
    </div>

    <!-- Tabs Content -->
    <div>
      <div v-if="activeTab === 'Informations générales'">
        <GeneralInfo
          :project="project"
        />
      </div>
      <div v-if="activeTab === 'Actions'">
        <Actions class="px-4"
          :project="project"
        />
      </div>
      <div v-if="activeTab === 'Planning'">
        <ShowPlanning :project="project" />
      </div>
      <div v-if="activeTab === 'Trésorerie'">
        <ShowCash :project="project"/>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectHeader from "./ProjectHeader.vue";

import GeneralInfo from "./GeneralInfo.vue";
import Actions from "./Actions.vue";
import FurtherInfo from "./FurtherInfo/FurtherInfo.vue";
import ShowCash from "@/views/App/ShowCash.vue";
import ShowPlanning from "@/views/App/ShowPlanning.vue";

import { fetchProjectDetails, updateProject } from "@/services/projectService";

export default {
  name: "ProjectDetails",
  components: { GeneralInfo, ProjectHeader, FurtherInfo, Actions, ShowCash, ShowPlanning },
  props: {
    id: String,
  },
  data() {
    return {
      project: {
        ressources: [], // Initialize ressources to an empty array
        clientId: null
      },
      isEditing: false,
      activeTab: "Informations générales", // Onglet actif par défaut
      tabs: ["Informations générales", "Actions", "Planning", "Trésorerie"],
    };
  },
  methods: {
    async fetchProjectData() {
      try {
        const projectData = await fetchProjectDetails(this.id);
        
        this.project = {
          ...projectData,
          startDate: new Date(projectData.startDate).toISOString().slice(0, 10), // Convert to YYYY-MM-DD
          endDate: new Date(projectData.endDate).toISOString().slice(0, 10) // Convert to YYYY-MM-DD
        };
      } catch (error) {
        console.error("Error fetching project data:", error);
      }
    },
    updateProject() {
      updateProject(this.project);
    }
  },
  async mounted() {
    await this.fetchProjectData();
    console.log("ProjectDetails mounted", this.project);
  },
  watch: {
    project: {
      handler() {
        this.updateProject();
      },
      deep: true
    }
  },
};
</script>